import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ITipResponse } from '../models/tip';
import { IAssessCaseCreate, IStudentCreate, IStudentInfo, IStudentUpdate } from '../models/assess';

@Injectable({
  providedIn: 'root'
})
export class NsideAssessService {

    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    findStudentBySsid(regionId: string, data: {building_id: string, student_identifier: string}): Observable<any> {
      const url = environment.assessApiBaseUrl + endpoints.findStudentBySsid.replace(':regionId', regionId);
      return this.http.post(url, data).pipe(
        catchError(this.errorService.handleError)
      );
    }

    findAssessCaseBySsid(ssid: {building_id: string, student_identifier: string}): Observable<any> {
        const url = environment.assessApiBaseUrl + endpoints.getAllAssessCasesByStudentID;
        return this.http.post(url, ssid).pipe(
            catchError(this.errorService.handleError)
        );
    }
  
    // create new student and new case for that student
    createStudent(regionId: string, studentData: IStudentCreate): Observable<any> {
      const url = environment.assessApiBaseUrl + endpoints.createStudent.replace(':regionId', regionId);
      return this.http.post(url, studentData).pipe(
        catchError(this.errorService.handleSavingError)
      );
    }
  
    updateStudent(regionId: string, updateData: Array<IStudentUpdate>): Observable<any> {
      const url = environment.assessApiBaseUrl + endpoints.updateStudent.replace(':regionId', regionId);
      return this.http.post(url, updateData).pipe(
        catchError(this.errorService.handleSavingError)
      );
    }

    createNewCaseForExistingStudent(data: IAssessCaseCreate): Observable<any> {
        const url = environment.assessApiBaseUrl + endpoints.createNewCaseForExistingStudent;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}